import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=a203b692&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=js&"
export * from "./TeacherList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=a203b692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a203b692",
  null
  
)

export default component.exports